import { of } from 'rxjs';
import { map, switchMap, take, filter } from 'rxjs/operators';
import { jobGuidManagerFactory } from '@shipstation/async-client-manager';

import { SERVER_BULK_ACTION_COST_REVIEW } from '../../services/pusher-service/pusher-contract-messages';
import { createPusherMessageCache } from '../pusher/message-cache';
import { COST_REVIEW_TIMEOUT_ALLOWED_RESTARTS } from './constants';
import { noop } from 'ui-components/default-props/noop';

const completeCheck = (pusherMsg, jobGuids) => {
  const [jobGuid] = jobGuids;
  return pusherMsg.messageGuid === jobGuid;
};

const timeoutRetryCheck = ({ messages, retryCount }) => {
  const hasNoMessages = !messages?.length;
  return !!(hasNoMessages && retryCount < COST_REVIEW_TIMEOUT_ALLOWED_RESTARTS);
};

const timeoutCompleteCheck = ({ messages }) => {
  return messages?.length === 1;
};

const timeoutFailureCheck = ({ messages, retryCount }) => {
  const hasNoMessages = !messages?.length;
  return !!(hasNoMessages && retryCount >= COST_REVIEW_TIMEOUT_ALLOWED_RESTARTS);
};

export const startCostReviewGetMessages = ({ apiCallback, pusherTimeoutMs, onError, logContext }) => {
  const jobGuidManager = jobGuidManagerFactory();
  const fallbackOptions = {
    timeoutMs: pusherTimeoutMs,
    jobGuidManager,
    // cost review is only one message, no need to reset
    resetTimeoutCheck: noop,
    completeCheck,
    timeoutCompleteCheck,
    timeoutRetryCheck,
    timeoutFailureCheck,
    onTimeout: onError,
    logContext,
  };
  const { findMessage } = createPusherMessageCache(SERVER_BULK_ACTION_COST_REVIEW, fallbackOptions);

  return apiCallback().pipe(
    switchMap(({ jobGuids }) => {
      const [jobGuid] = jobGuids;
      jobGuidManager.addJobGuid(jobGuid);
      const messageChecker = (pusherMessage) => pusherMessage.messageGuid === jobGuid;
      return of({
        jobGuids,
        findMessage$: findMessage(messageChecker).pipe(
          take(1),
          map((pusherMessage) => {
            if (pusherMessage.data?.errorMessage) {
              onError({
                jobGuids: [jobGuid],
                errorOnMessage: pusherMessage.data.errorMessage,
              });
              return;
            }
            return { pusherData: pusherMessage.data };
          }),
          filter((next) => !!next?.pusherData),
        ),
      });
    }),
  );
};
